var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VRadio',_vm._b({class:_vm.classList,scopedSlots:_vm._u([{key:"label",fn:function(){return [_vm._t("label")]},proxy:true}],null,true)},'VRadio',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }